module.exports = __webpack_public_path__ + "double-division2-jp-desktop.jpg";